import React from 'react';
import { CheckCircle, Clock, Loader2, XCircle } from 'lucide-react';
import type { ReportHistoryItem } from './ReportHistory';

type RunStatus = ReportHistoryItem['status'] | 'draft' | 'finalized' | 'readyforview' | 'processing' | 'failed';

const badgeStyles: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  processing: 'bg-blue-100 text-blue-800 border-blue-200',
  completed: 'bg-green-100 text-green-800 border-green-200',
  failed: 'bg-red-100 text-red-800 border-red-200',
  draft: 'bg-amber-100 text-amber-800 border-amber-200',
  readyforview: 'bg-sky-100 text-sky-800 border-sky-200',
  finalized: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

const statusLabels: Record<string, string> = {
  pending: 'Pending',
  processing: 'Processing',
  completed: 'Completed',
  failed: 'Failed',
  draft: 'Draft',
  readyforview: 'Ready for View',
  finalized: 'Finalized',
};

export function ReportRunStatusBadge({ status }: { status: RunStatus }) {
  const key = String(status || 'pending').toLowerCase().replace(/\s+/g, '');
  const label = statusLabels[key] ?? key.charAt(0).toUpperCase() + key.slice(1);

  const icon =
    key === 'processing' ? (
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
    ) : key === 'completed' || key === 'finalized' || key === 'readyforview' ? (
      <CheckCircle className="h-3.5 w-3.5" />
    ) : key === 'failed' ? (
      <XCircle className="h-3.5 w-3.5" />
    ) : (
      <Clock className="h-3.5 w-3.5" />
    );

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded border ${badgeStyles[key] ?? badgeStyles.pending}`}
    >
      {icon}
      {label}
    </span>
  );
}

export default ReportRunStatusBadge;
